import { NpoPaymentAccountStepsResult } from '@/api/models/paymentAccountsModels';

export enum NpoMerchantOnboardingRoutes {
  TERMS = '/npoPaymentOnboarding',
  ACH_TERMS = '/npoPaymentOnboarding/achTerms',
  GENERAL = '/npoPaymentOnboarding/general',
  OWNER = '/npoPaymentOnboarding/owner',
  RISK_PROFILE = '/npoPaymentOnboarding/riskProfile',
  BANK_ACCOUNT = '/npoPaymentOnboarding/bankAccount',
  DOCUMENTS = '/npoPaymentOnboarding/documents'
}

type StepKey = keyof typeof NpoMerchantOnboardingRoutes;

type Step = {
  key: StepKey;
  route: NpoMerchantOnboardingRoutes;
  completed: (data: NpoPaymentAccountStepsResult) => boolean;
};

export const NPO_ONBOARDING_STEPS: Step[] = [
  {
    key: 'GENERAL',
    route: NpoMerchantOnboardingRoutes.GENERAL,
    completed: (data) => data.companySaved
  },
  {
    key: 'OWNER',
    route: NpoMerchantOnboardingRoutes.OWNER,
    completed: (data) => data.ownerPrincipalSaved
  },
  {
    key: 'RISK_PROFILE',
    route: NpoMerchantOnboardingRoutes.RISK_PROFILE,
    completed: (data) => data.riskProfileSaved
  },
  {
    key: 'BANK_ACCOUNT',
    route: NpoMerchantOnboardingRoutes.BANK_ACCOUNT,
    completed: (data) => data.bankSaved
  },
  {
    key: 'DOCUMENTS',
    route: NpoMerchantOnboardingRoutes.DOCUMENTS,
    completed: (data) => data.docsUploadSaved
  }
];
